<template>
	<div>

		<!-- Filter Start -->
		<div class="innerBox mb-4">
			<div class="row">
				<div class="col-md-2">
					<a class="navbar-brand ml-3" style="font: normal normal normal 16px/25px Poppins;">Cari SJ</a>
				</div>
				<div class="col-md-8" style="">
					<input class="form-control filterInput" type="search" placeholder="Masukkan Nomor SJ" aria-label="Search"
						style="display: flex; font: normal normal normal 16px/25px Poppins;" v-model="filter.search">
				</div>
				<div class="col-md-2 text-right" style="display: flex; justify-content: flex-end">
					<button class="btn" type="button" style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
						@click="vue_universal_table.update++">CARI</button>
				</div>
			</div>
		</div>
		<!-- Filter End -->

		<!-- Table Start -->
		<div class="innerBox">

			<div class="mb-4 d-flex align-items-center justify-content-between">
				<div class="text-center" style="flex: 1; margin-left: 38%;">
					<h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">List SJ</h3>
				</div>
				<div class="d-flex align-items-center" style="gap: 15px;">
					<div style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
						<span style="font: normal normal normal 12px/18px Poppins;">Filter tanggal</span>
					</div>
					<div style="width: 200px; flex-shrink: 0;">
						<flat-pickr :config="rangePickr" placeholder="Select Date" v-model="selected.date"
							style="font: normal normal normal 12px/18px Poppins; width: 100% !important;"></flat-pickr>
					</div>
					<div class="d-flex" style="gap: 8px; flex-shrink: 0;">
						<button class="btn" type="button" style="
          background-color: #f36f21;
          color: white;
          font-weight: bold;
          padding: 8px 16px;
          white-space: nowrap;
          font: normal normal 600 14px/21px Poppins;
        " @click="exportExcel">
							Export Excel
						</button>
						<button class="btn" :class="{ 'd-none': hideButton }" type="button" style="
          background-color: #f36f21;
          color: white;
          font-weight: bold;
          padding: 8px 16px;
          white-space: nowrap;
          font: normal normal 600 14px/21px Poppins;
        " @click="showModalMultiple">
							Edit
						</button>
					</div>
				</div>
			</div>

			<vue-universal-table ref="universalTable" api_url="/api/monitoring/list-transfer-to" :filter="filter"
				:update="vue_universal_table.update" :fields="vue_universal_table.fields" :buttons="vue_universal_table.buttons"
				:infinite_scroll="true" :multiple_select="true" :select_row_variable="'id'"
				@onSelectionChange="handleSelectionChange" @fetchEnd="handleFetchEnd" sort_order="DESC" @onEdit="showModal"
				@onDelete="handleDeleteTo" sort_by="tgl_sl"
				style="font: normal normal normal 12px/18px Poppins;"></vue-universal-table>

			<UpdateTransferTO :data="modal.data" v-if="modal.edit" @closeModal="modal.edit = false"
				@refreshTable="refreshAfterTransfer" />
		</div>
		<!-- Table End -->
	</div>
</template>

<script>
import moment from 'moment';
import debounce from 'debounce';
import qs from 'qs';
import UpdateTransferTO from './children/UpdateTransferTO';

export default {
	metaInfo: {
		title: 'Monitoring Transfer TO'
	},
	data() {
		let startDate = moment().startOf('year').format("YYYY-MM-DD");
		let currentDate = moment().format("YYYY-MM-DD");

		return {
			rangePickr: {
				mode: 'range',
				dateFormat: "Y-m-d",
				altInput: true,
				altFormat: "d-m-Y",
				altInputClass: 'form-control input mpm--transporter--flatpickr'
			},
			hideButton: true,
			modal: {
				data: null,
				edit: false
			},
			selected: {
				dateButtonsIndex: 2,
				date: `${startDate} to ${currentDate}`
			},
			filter: {
				search: '',
				start: startDate,
				end: currentDate
			},
			vue_universal_table: {
				fields: [
					{ title: "NO SJ", variable: "no_sl" },
					{ title: "NO TO", variable: "no_referensi", disable_sort: true },
					{ title: "TANGGAL SJ/TO", variable: "tgl_sl" },
					{ title: "NOPOL", variable: "nopol" }
				],
				buttons: [
					{ title: 'Edit', variable: null, class: 'rounded shadow fas fa-pencil' },
					{ title: "Delete", variable: "id", class: "fas fa-trash btn-outline-danger" },
				],
				update: 0,
				data: []
			},
			selectedRowIds: [],
			selectedFullData: [],
			persistentSelectedData: []
		}
	},
	components: {
		UpdateTransferTO
	},
	mounted() {
		document.body.classList.add('transfer-to-page');
	},
	beforeDestroy() {
		document.body.classList.remove('transfer-to-page');
	},
	watch: {
		'selected.date'() {
			let split = this.selected.date.split(" to ");
			this.filter.start = split[0];
			this.filter.end = split.length > 1 ? split[1] : split[0];

			this.updateDebounceData();
		},
		'selectedFullData'() {
			if (this.selectedFullData.length > 0) {
				this.hideButton = false;
			} else {
				this.hideButton = true;
			}
		}
	},
	methods: {
		updateDebounceData: debounce(function () {
			this.vue_universal_table.update++
		}, 1500),
		showModal(data) {
			this.modal.data = data;
			this.modal.edit = true;
		},
		showModalMultiple() {
			this.modal.data = this.selectedFullData;
			this.modal.edit = true;
		},
		handleSelectionChange(selectedRowIds) {
			this.selectedRowIds = selectedRowIds;

			// Get currently visible selected data
			const currentlySelectedData = this.vue_universal_table.data.filter(row =>
				selectedRowIds.includes(row.id)
			);

			// Remove previously selected items that are now unselected from current view
			const currentViewIds = this.vue_universal_table.data.map(row => row.id);
			const unselectedFromCurrentView = currentViewIds.filter(id =>
				!selectedRowIds.includes(id)
			);
			this.persistentSelectedData = this.persistentSelectedData.filter(row =>
				!unselectedFromCurrentView.includes(row.id)
			);

			// Add newly selected items from current view
			currentlySelectedData.forEach(newItem => {
				const existsInPersistent = this.persistentSelectedData.some(item =>
					item.id === newItem.id
				);
				if (!existsInPersistent) {
					this.persistentSelectedData.push(newItem);
				}
			});

			// Update selectedFullData to show all persistent selections
			this.selectedFullData = [...this.persistentSelectedData];
		},
		refreshAfterTransfer() {
			this.selectedRowIds = [];
			this.selectedFullData = [];
			this.persistentSelectedData = [];

			if (this.$refs.universalTable) {
				this.$refs.universalTable.selectedRows = [];
				this.$refs.universalTable.selectAll = false;
			}

			this.vue_universal_table.update++;
		},
		handleFetchEnd() {
			if (this.$refs.universalTable && this.$refs.universalTable.tableData) {
				this.vue_universal_table.data = this.$refs.universalTable.tableData;

				// Restore checkbox states for items that are still selected
				this.$nextTick(() => {
					if (this.$refs.universalTable) {
						const currentViewIds = this.vue_universal_table.data.map(row => row.id);
						const selectedIdsInCurrentView = this.persistentSelectedData
							.filter(item => currentViewIds.includes(item.id))
							.map(item => item.id);

						// Update the table's selected rows
						this.$refs.universalTable.selectedRows = selectedIdsInCurrentView;
						this.selectedRowIds = selectedIdsInCurrentView;
					}
				});
			}
		},
		exportExcel() {
			if (this.filter.search === '') delete this.filter.search;

			this.$http.get(`/api/monitoring/list-transfer-to/export-excel?${qs.stringify(this.filter, { skipNulls: true, arrayFormat: 'comma' })}`, { responseType: 'blob' })
				.then((response) => {
					// create file link in browser's memory
					const href = URL.createObjectURL(response.data);

					// create "a" HTML element with href to file & click
					const link = document.createElement('a');
					link.href = href;
					link.setAttribute('download', `transfer-to-${moment().format('YYYYMMDDHHmmss')}.xlsx`); //or any other extension
					document.body.appendChild(link);
					link.click();

					// clean up "a" element & remove ObjectURL
					document.body.removeChild(link);
					URL.revokeObjectURL(href);
				});
		},
		handleDeleteTo(id) {
			this.$swal.fire({
				title: 'Apakah Anda yakin?',
				text: "data yang telah dihapus tidak dapat dikembalikan lagi",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Hapus',
				cancelButtonText: "Batal",
				reverseButtons: true
			}).then((result) => {
				if (result.value) {
					this.$http.delete("/api/monitoring/delete-to/" + id)
						.then(() => {
							this.$swal.fire({
								title: "Success!",
								icon: "success",
								type: "success",
								text: `Berhasil Hapus TO`
							})
							this.vue_universal_table.update++;
						}).catch((error) => {
							this.$swal.fire({
								title: "Error!",
								icon: "error",
								type: "error",
								text: error.response.data.message
							})
						})
				}
			})
		}
	}
}
</script>

<style>
body.transfer-to-page .swal2-confirm,
body.transfer-to-page .swal2-confirm.swal2-styled {
	background-color: #EB5757 !important;
	color: white !important;
	padding: 10px 30px !important;
	border-radius: 6px !important;
	font-size: 16px !important;
	font-weight: 500 !important;
	border: none !important;
	box-shadow: none !important;
	min-width: 120px !important;
	margin: 0 5px !important;
}

body.transfer-to-page .swal2-confirm:hover,
body.transfer-to-page .swal2-confirm.swal2-styled:hover {
	background-color: #d63447 !important;
	transform: none !important;
}

body.transfer-to-page .swal2-cancel,
body.transfer-to-page .swal2-cancel.swal2-styled {
	background-color: #1B698E !important;
	color: white !important;
	border: none !important;
	padding: 10px 30px !important;
	border-radius: 6px !important;
	font-size: 16px !important;
	font-weight: 500 !important;
	min-width: 120px !important;
	margin: 0 5px !important;
}

body.transfer-to-page .swal2-cancel:hover,
body.transfer-to-page .swal2-cancel.swal2-styled:hover {
	background-color: #155a75 !important;
	transform: none !important;
}

body.transfer-to-page .swal2-actions {
	gap: 10px !important;
}
</style>

<style scoped>
.innerBox {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000F;
	padding: 20px;

}

.chart {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000F;
	padding: 20px;
	align-items: center;
}

.elegant--sub-title {
	font-size: 18px;
	font-weight: 500;
	color: #9F9F9F;
}

.tableTitle {
	text-align: center;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.table td,
.table th {
	text-align: center;
}
</style>
